function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10S0 15.522 0 10 4.477 0 10 0z",
  fill: "#7EC500",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 9.748V4.541c0-.406.192-.603.59-.604l4.483-.004c.148 0 .27.057.374.163l3.287 3.344c.104.105.158.23.158.381l-.004 7.158c0 .301-.134.501-.382.567a.642.642 0 01-.164.017H6.544c-.339 0-.544-.21-.544-.556V9.748z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7EC500",
  fillRule: "nonzero",
  d: "M10.3 3.933h1V8h-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7EC500",
  fillRule: "nonzero",
  d: "M15 7.5v1h-4.7v-1z"
}))));